import React from "react";

class Look extends React.Component {
  Del = e => {
    this.props.clickDeleteImg();
  };
  render() {
    return (
      <svg
        id="_x34_22fdd6b-e2b3-4c8c-a720-ac850a644b1c"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 28 24"
        width={this.props.width}
        height={this.props.height}
      >
        <path
          id="_x35_8055f8e-b983-40b0-8fec-8927269f1c3f"
          fill="#000"
          d="M25.473 12.225a.871.871 0 0 1-.592-.232c-3.628-3.341-7.338-5.036-11.026-5.036-.233 0-.469.007-.702.021-4.711.275-8.243 3.179-9.93 4.885a.864.864 0 0 1-1.148.076l-.739-.583a.857.857 0 0 1-.083-1.273C3.213 8.076 7.345 4.66 12.998 4.33c.288-.017.581-.025.869-.025 4.385 0 8.709 1.944 12.854 5.777a.86.86 0 0 1 .017 1.232l-.663.663a.843.843 0 0 1-.602.248"
        />
        <path
          id="d35d6c23-4335-4a7b-aef1-1e665eb41360"
          fill="#000"
          d="M14 11.596a2.79 2.79 0 1 0 2.788 2.789v-.001A2.793 2.793 0 0 0 14 11.596m0 8.1a5.311 5.311 0 1 1 5.311-5.312A5.317 5.317 0 0 1 14 19.696"
        />
      </svg>
    );
  }
}

export default Look;
